"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExampleSerializedNestedRoot = "62e376e7-5e02-4fda-9b2e-fe75f59064cc";
exports.ExampleSerializedNested = {
    "62e376e7-5e02-4fda-9b2e-fe75f59064cc": {
        id: "62e376e7-5e02-4fda-9b2e-fe75f59064cc",
        type: "Module",
        props: {},
        children: [
            { id: "afaf91cb-894c-4f30-92f3-88c0434044e7", type: "Ref" },
            { id: "d45955b4-50af-47f6-919c-7ff443b88de6", type: "Ref" }
        ]
    },
    "afaf91cb-894c-4f30-92f3-88c0434044e7": {
        id: "afaf91cb-894c-4f30-92f3-88c0434044e7",
        type: "Header",
        props: {
            sticky: "top"
        },
        children: [
            { id: "420b641b-9c33-4169-b6fc-23e1c3756975", type: "Ref" },
            { id: "03e9c4e5-9d55-45c1-abf3-46ef460e73c4", type: "Ref" },
            { id: "441a2e33-d06f-4822-899a-323025f8fc52", type: "Ref" },
            { id: "746d06da-fa25-4b6f-be82-edfa6f052d88", type: "Ref" }
        ]
    },
    "420b641b-9c33-4169-b6fc-23e1c3756975": {
        id: "420b641b-9c33-4169-b6fc-23e1c3756975",
        type: "Back"
    },
    "03e9c4e5-9d55-45c1-abf3-46ef460e73c4": {
        id: "03e9c4e5-9d55-45c1-abf3-46ef460e73c4",
        type: "TopicTitle"
    },
    "441a2e33-d06f-4822-899a-323025f8fc52": {
        id: "441a2e33-d06f-4822-899a-323025f8fc52",
        type: "Logo"
    },
    "746d06da-fa25-4b6f-be82-edfa6f052d88": {
        id: "746d06da-fa25-4b6f-be82-edfa6f052d88",
        type: "Menu"
    },
    "d45955b4-50af-47f6-919c-7ff443b88de6": {
        id: "d45955b4-50af-47f6-919c-7ff443b88de6",
        type: "AnimationGroup",
        meta: {
            subType: "Topic"
        },
        children: [
            {
                id: "50c7d9d7-304c-47e7-ac2a-9e4439ccfb0f",
                type: "Ref"
            }
        ]
    },
    "50c7d9d7-304c-47e7-ac2a-9e4439ccfb0f": {
        id: "50c7d9d7-304c-47e7-ac2a-9e4439ccfb0f",
        type: "Topic",
        props: { name: "welcome" },
        children: [
            {
                id: "1690aa8f-2016-46dd-baa0-be5340b84aa0",
                type: "Ref"
            }
        ]
    },
    "1690aa8f-2016-46dd-baa0-be5340b84aa0": {
        id: "1690aa8f-2016-46dd-baa0-be5340b84aa0",
        type: "AnimationGroup",
        props: {},
        meta: {
            subType: "Interaction"
        },
        animator: {
            type: "ScrollAnimator",
            config: {}
        },
        children: [{ id: "d3ddb5d5-212e-4a4e-81fa-8de0be3a0316", type: "Ref" }]
    },
    "d3ddb5d5-212e-4a4e-81fa-8de0be3a0316": {
        id: "d3ddb5d5-212e-4a4e-81fa-8de0be3a0316",
        type: "Interaction",
        props: {
            name: "intro"
        },
        children: [{ id: "725d0fbf-f7eb-43f8-b08d-2dfb263a550c", type: "Ref" }]
    },
    "725d0fbf-f7eb-43f8-b08d-2dfb263a550c": {
        id: "725d0fbf-f7eb-43f8-b08d-2dfb263a550c",
        type: "SingleColumnLayout",
        children: [
            {
                id: "4e71a6dc-a101-47d7-9277-e3b14805a35e",
                type: "Ref"
            }
        ]
    },
    "4e71a6dc-a101-47d7-9277-e3b14805a35e": {
        id: "4e71a6dc-a101-47d7-9277-e3b14805a35e",
        type: "Column",
        props: {
            align: "center"
        },
        children: [
            {
                id: "04d365f3-a2ae-4970-9f3d-af259d5fec70",
                type: "Ref"
            },
            {
                id: "385afaf3-48a6-491a-b3bd-a0c2c4938c70",
                type: "Ref"
            },
            {
                id: "2238f67f-242d-413e-93d9-68f87a350ca2",
                type: "Ref"
            }
        ]
    },
    "04d365f3-a2ae-4970-9f3d-af259d5fec70": {
        id: "04d365f3-a2ae-4970-9f3d-af259d5fec70",
        type: "Text",
        children: [
            {
                id: "09d9ed61-4c03-48d9-a151-c552b581b64c",
                type: "Ref"
            },
            {
                id: "80f683c3-d5b8-4fd7-bedf-ec49ecdeac5b",
                type: "Ref"
            }
        ]
    },
    "09d9ed61-4c03-48d9-a151-c552b581b64c": {
        id: "09d9ed61-4c03-48d9-a151-c552b581b64c",
        type: "Heading",
        children: "Module Title"
    },
    "80f683c3-d5b8-4fd7-bedf-ec49ecdeac5b": {
        id: "80f683c3-d5b8-4fd7-bedf-ec49ecdeac5b",
        type: "Paragraph",
        children: "Welcome text explaining what this module is about"
    },
    "ee79d1b0-2fdd-4efd-9e52-507d2b25ee07": {
        id: "ee79d1b0-2fdd-4efd-9e52-507d2b25ee07",
        type: "Image",
        props: {
            src: "https://dummyimage.com/400x300/333/d5d6ed.png"
        }
    },
    "752f8931-7395-4f01-9e4b-9ace9865236a": {
        id: "752f8931-7395-4f01-9e4b-9ace9865236a",
        type: "Text",
        children: "Slide A"
    },
    "2441aebc-4a8e-4d7b-88c2-7850b4390f2f": {
        id: "2441aebc-4a8e-4d7b-88c2-7850b4390f2f",
        type: "Slide",
        children: [
            {
                id: "ee79d1b0-2fdd-4efd-9e52-507d2b25ee07",
                type: "Ref"
            },
            {
                id: "752f8931-7395-4f01-9e4b-9ace9865236a",
                type: "Ref"
            }
        ]
    },
    "66900c97-0381-4a9d-9533-95125b08d548": {
        id: "66900c97-0381-4a9d-9533-95125b08d548",
        type: "Text",
        children: "Slide B"
    },
    "e6cf5d47-1ce3-4300-a892-c2543bbf1ab1": {
        id: "e6cf5d47-1ce3-4300-a892-c2543bbf1ab1",
        type: "Image",
        props: {
            src: "https://dummyimage.com/400x300/333/d5d6ed.png"
        }
    },
    "8ccd4fcf-fee8-43f1-bddc-3defb9184d8a": {
        id: "8ccd4fcf-fee8-43f1-bddc-3defb9184d8a",
        type: "Slide",
        children: [
            {
                id: "e6cf5d47-1ce3-4300-a892-c2543bbf1ab1",
                type: "Ref"
            },
            {
                id: "66900c97-0381-4a9d-9533-95125b08d548",
                type: "Ref"
            }
        ]
    },
    "df8164c8-f51f-4de4-bc1b-c527ac09308f": {
        id: "df8164c8-f51f-4de4-bc1b-c527ac09308f",
        type: "Image",
        props: {
            src: "https://dummyimage.com/400x300/333/d5d6ed.png"
        }
    },
    "9c33776c-3eaf-4032-8cdd-a630e516072e": {
        id: "9c33776c-3eaf-4032-8cdd-a630e516072e",
        type: "Text",
        children: "Slide C"
    },
    "e2364ede-ff20-4894-9ef3-c71c0f154b0a": {
        id: "e2364ede-ff20-4894-9ef3-c71c0f154b0a",
        type: "Slide",
        children: [
            {
                id: "df8164c8-f51f-4de4-bc1b-c527ac09308f",
                type: "Ref"
            },
            {
                id: "9c33776c-3eaf-4032-8cdd-a630e516072e",
                type: "Ref"
            }
        ]
    },
    "385afaf3-48a6-491a-b3bd-a0c2c4938c70": {
        id: "385afaf3-48a6-491a-b3bd-a0c2c4938c70",
        type: "Carousel",
        children: [
            {
                id: "2441aebc-4a8e-4d7b-88c2-7850b4390f2f",
                type: "Ref"
            },
            {
                id: "8ccd4fcf-fee8-43f1-bddc-3defb9184d8a",
                type: "Ref"
            },
            {
                id: "e2364ede-ff20-4894-9ef3-c71c0f154b0a",
                type: "Ref"
            }
        ]
    },
    "2238f67f-242d-413e-93d9-68f87a350ca2": {
        id: "2238f67f-242d-413e-93d9-68f87a350ca2",
        type: "ContinueButton",
        children: "Continue"
    }
};
exports.ExampleSerialized = {
    id: "62e376e7-5e02-4fda-9b2e-fe75f59064cc",
    type: "Module",
    props: {},
    children: [
        {
            id: "d45955b4-50af-47f6-919c-7ff443b88de6",
            type: "AnimationGroup",
            meta: {
                subType: "Topic"
            },
            children: [
                {
                    id: "50c7d9d7-304c-47e7-ac2a-9e4439ccfb0f",
                    type: "Topic",
                    props: { name: "welcome" },
                    children: [
                        {
                            id: "1690aa8f-2016-46dd-baa0-be5340b84aa0",
                            type: "AnimationGroup",
                            meta: {
                                subType: "Interaction"
                            },
                            props: {},
                            animator: {
                                type: "ScrollAnimator",
                                config: {}
                            },
                            children: [
                                {
                                    id: "d3ddb5d5-212e-4a4e-81fa-8de0be3a0316",
                                    type: "Interaction",
                                    props: {
                                        name: "intro"
                                    },
                                    children: [
                                        {
                                            id: "725d0fbf-f7eb-43f8-b08d-2dfb263a550c",
                                            type: "SingleColumnLayout",
                                            children: [
                                                {
                                                    id: "4e71a6dc-a101-47d7-9277-e3b14805a35e",
                                                    type: "Column",
                                                    props: {
                                                        align: "center"
                                                    },
                                                    children: [
                                                        {
                                                            id: "04d365f3-a2ae-4970-9f3d-af259d5fec70",
                                                            type: "Text",
                                                            children: [
                                                                {
                                                                    id: "09d9ed61-4c03-48d9-a151-c552b581b64c",
                                                                    type: "Heading",
                                                                    children: "Module Title"
                                                                },
                                                                {
                                                                    id: "80f683c3-d5b8-4fd7-bedf-ec49ecdeac5b",
                                                                    type: "Paragraph",
                                                                    children: "Welcome text explaining what this module is about"
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            id: "385afaf3-48a6-491a-b3bd-a0c2c4938c70",
                                                            type: "Carousel",
                                                            children: [
                                                                {
                                                                    id: "2441aebc-4a8e-4d7b-88c2-7850b4390f2f",
                                                                    type: "Slide",
                                                                    children: [
                                                                        {
                                                                            id: "ee79d1b0-2fdd-4efd-9e52-507d2b25ee07",
                                                                            type: "Image",
                                                                            props: {
                                                                                src: "https://dummyimage.com/400x300/333/d5d6ed.png"
                                                                            }
                                                                        },
                                                                        {
                                                                            id: "752f8931-7395-4f01-9e4b-9ace9865236a",
                                                                            type: "Paragraph",
                                                                            children: "Slide A"
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    id: "8ccd4fcf-fee8-43f1-bddc-3defb9184d8a",
                                                                    type: "Slide",
                                                                    children: [
                                                                        {
                                                                            id: "e6cf5d47-1ce3-4300-a892-c2543bbf1ab1",
                                                                            type: "Image",
                                                                            props: {
                                                                                src: "https://dummyimage.com/400x300/333/d5d6ed.png"
                                                                            }
                                                                        },
                                                                        {
                                                                            id: "66900c97-0381-4a9d-9533-95125b08d548",
                                                                            type: "Paragraph",
                                                                            children: "Slide B"
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    id: "e2364ede-ff20-4894-9ef3-c71c0f154b0a",
                                                                    type: "Slide",
                                                                    children: [
                                                                        {
                                                                            id: "df8164c8-f51f-4de4-bc1b-c527ac09308f",
                                                                            type: "Image",
                                                                            props: {
                                                                                src: "https://dummyimage.com/400x300/333/d5d6ed.png"
                                                                            }
                                                                        },
                                                                        {
                                                                            id: "9c33776c-3eaf-4032-8cdd-a630e516072e",
                                                                            type: "Paragraph",
                                                                            children: "Slide C"
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            id: "2238f67f-242d-413e-93d9-68f87a350ca2",
                                                            type: "ContinueButton",
                                                            children: "Continue"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    id: "e9f6f212-250c-409d-a14d-68838c7e1bc3",
                                    type: "Interaction",
                                    props: {
                                        name: "number-two"
                                    },
                                    children: [
                                        {
                                            id: "07f3cadd-7abc-4d19-8073-0ed0155627ac",
                                            type: "SingleColumnLayout",
                                            children: [
                                                {
                                                    type: "Column",
                                                    props: {
                                                        align: "center"
                                                    },
                                                    children: [
                                                        {
                                                            id: "610e47ed-eb35-44d6-9c00-d5db5179d21d",
                                                            type: "Text",
                                                            children: [
                                                                {
                                                                    id: "",
                                                                    type: "Heading",
                                                                    children: "Section 2"
                                                                },
                                                                {
                                                                    id: "",
                                                                    type: "Paragraph",
                                                                    children: "Welcome text explaining what this module is about"
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            id: "7fbd0b94-684d-49f2-acb2-8624ead6b634",
                                                            type: "Carousel",
                                                            children: [
                                                                {
                                                                    id: "cf6e7f24-6e91-4cb9-ba94-55d0183bf4a3",
                                                                    type: "Slide",
                                                                    children: [
                                                                        {
                                                                            id: "0ef952ca-72c2-465e-a33b-32a474dd557f",
                                                                            type: "Image",
                                                                            props: {
                                                                                src: "https://dummyimage.com/400x300/333/d5d6ed.png"
                                                                            }
                                                                        },
                                                                        {
                                                                            id: "1a284c98-6727-4e42-bb82-4735c325bb4b",
                                                                            type: "Paragraph",
                                                                            children: "Slide A"
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    id: "eba83134-5738-478c-a719-2b4b3a8732ba",
                                                                    type: "Slide",
                                                                    children: [
                                                                        {
                                                                            id: "9e27942b-3252-4b6a-ab02-2543a07451cf",
                                                                            type: "Image",
                                                                            props: {
                                                                                src: "https://dummyimage.com/400x300/333/d5d6ed.png"
                                                                            }
                                                                        },
                                                                        {
                                                                            id: "a9b357ac-f28a-4d23-8877-d9796b3154c1",
                                                                            type: "Paragraph",
                                                                            children: "Slide B"
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    id: "cbe3b6b7-5f93-41f7-b449-404ac0b7fd4f",
                                                                    type: "Slide",
                                                                    children: [
                                                                        {
                                                                            id: "c911107d-54c6-45ca-a5f0-3e66b886bfed",
                                                                            type: "Image",
                                                                            props: {
                                                                                src: "https://dummyimage.com/400x300/333/d5d6ed.png"
                                                                            }
                                                                        },
                                                                        {
                                                                            id: "e5e02602-b8e6-4c20-a340-fc2a3178f897",
                                                                            type: "Paragraph",
                                                                            children: "Slide C"
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            id: "381ad80c-5e01-4c77-96ac-d78037cd3a6a",
                                                            type: "ContinueButton",
                                                            children: "Continue"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ]
};
